import React, { Component } from 'react'
import ServicesSidebar from './ServicesSidebar'
import Banner from '../../components/common/Banner';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';

export default class LibraryMembership extends Component {

    render() {
        return (
            <div>
                {/* Header */}
                <Header />

                {/* Banner */}
                <Banner title="Services" image="banner/library-2.jpg" />

                <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
                    <div className="container-xl">
                        <div className="row">
                            <div className="col-lg-9 content-area order-lg-2">
                                <div className="ttm-service-single-content-area">
                                    <div className="section-title with-desc text-left clearfix">
                                        <div className="title-header" style={{ borderTopColor: "red" }}>
                                            <h4 className="title">Membership</h4>
                                        </div>
                                    </div>
                                    <table class="table">
                                        <thead style={{ backgroundColor: "#98002e", color: "white" }}>
                                            <tr>
                                                <th scope="col">Category of Membership</th>
                                                <th scope="col">No.Of Books</th>
                                                <th scope="col">Period of Loan</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Students Under Graduates(B.E)</td>
                                                <td>02</td>
                                                <td>15 Days</td>
                                            </tr>
                                            <tr>
                                                <td>Students Post Graduate (M.Tech/MCA/MBA)</td>
                                                <td>03</td>
                                                <td>15 days</td>
                                            </tr>
                                            <tr>
                                                <td>BookBank (SC/ST) Students</td>
                                                <td>03</td>
                                                <td>One Semester</td>
                                            </tr>
                                            <tr>
                                                <td>Faculty Teaching</td>
                                                <td>10</td>
                                                <td>One Semester</td>
                                            </tr>
                                            <tr>
                                                <td>Non-Teaching Staff</td>
                                                <td>02</td>
                                                <td>30 days</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="col-lg-3 widget-area">
                                <ServicesSidebar />
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
    
}
